import {api} from './api';
import {BiotwinShare, BiotwinShareStatus} from '../../features/biotwin-share/types';
import {identitiesApi} from './identitiesApi';
import {biotwinApi} from './biotwinApi';

export const biotwinShareApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createBiotwinShare: builder.mutation<
      BiotwinShare,
      {userId: number; biotwinShare: Pick<BiotwinShare, 'email' | 'message' | 'ownerDisplayName' | 'privilege'>}
    >({
      query: ({userId, biotwinShare}) => ({
        url: `/biotype-shares?userId=${userId}`,
        method: 'POST',
        body: biotwinShare,
      }),
      onQueryStarted: async (_arg, {dispatch, queryFulfilled}) => {
        try {
          const {data: biotwinShare} = await queryFulfilled;
          dispatch(
            biotwinShareApi.util.updateQueryData('getBiotwinShares', undefined, (biotwinShares) => {
              biotwinShares.push(biotwinShare);
            }),
          );
        } catch (e) {}
      },
    }),
    deleteBiotwinShare: builder.mutation<void, {id: number}>({
      query: (arg) => ({url: `/biotype-shares/${arg.id}`, method: 'DELETE'}),
      onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
        try {
          await queryFulfilled;
          dispatch(
            biotwinShareApi.util.updateQueryData('getBiotwinShares', undefined, (biotwinShares) => {
              const index = biotwinShares.findIndex((biotwinShare) => biotwinShare.id === arg.id);
              if (index !== -1) {
                biotwinShares.splice(index, 1);
              }
            }),
          );
        } catch (e) {}
      },
    }),
    getBiotwinShares: builder.query<BiotwinShare[], void>({
      query: () => ({url: `/biotype-shares`, method: 'GET'}),
      providesTags: ['BiotwinShares'],
    }),
    setBiotwinShareStatus: builder.mutation<void, {id: number; status: BiotwinShareStatus}>({
      query: (arg) => ({
        url: `/biotype-shares/${arg.id}/status`,
        method: 'PUT',
        body: {status: arg.status},
      }),
      onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
        try {
          await queryFulfilled;
          dispatch(
            biotwinShareApi.util.updateQueryData('getBiotwinShares', undefined, (biotwinShares) => {
              const index = biotwinShares.findIndex((biotwinShare) => biotwinShare.id === arg.id);
              if (index !== -1) {
                if (arg.status === BiotwinShareStatus.Rejected) {
                  biotwinShares.splice(index, 1);
                } else {
                  const biotwinShare = biotwinShares[index];
                  biotwinShare.status = arg.status;
                }
              }
            }),
          );
          if (arg.status === BiotwinShareStatus.Accepted) {
            await dispatch(identitiesApi.endpoints.refreshToken.initiate());
          }
          dispatch(biotwinApi.util.invalidateTags(['Biotwins']));
        } catch (e) {}
      },
    }),
  }),
});

export const {
  useCreateBiotwinShareMutation,
  useDeleteBiotwinShareMutation,
  useGetBiotwinSharesQuery,
  useLazyGetBiotwinSharesQuery,
  useSetBiotwinShareStatusMutation,
} = biotwinShareApi;
